import { render, staticRenderFns } from "./NewsAPIKeyEditView.vue?vue&type=template&id=bafe1280"
import script from "./NewsAPIKeyEditView.js?vue&type=script&lang=js&external"
export * from "./NewsAPIKeyEditView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports